<template>
  <div>
    <div class="container_wrap">
      <!-- <van-dialog v-model="dialogShowCurrent" title="订单详情" show-cancel-button @confirm="dialogConfirm" @cancel="dialogCancel">
        <div class="scroll_dialog">
            <van-cell-group>
                <template v-for="(item,index) in fieldArr">
                    <van-field :label="item.name" :value="item.value" readonly :key="index" rows="1" autosize type="textarea"/>
                </template>
            </van-cell-group>
            <template v-if="memberArr.length">
                <van-divider>人员信息</van-divider>
                <van-cell-group v-for="(item,index) in memberArr" :key="index">
                    <template v-for="(item2,index2) in item">
                        <van-field :label="item2.name" :value="item2.value" readonly  rows="1" autosize type="textarea" :key="index2"/>
                    </template>
                </van-cell-group> 
            </template>
        </div>
      </van-dialog> -->

      <el-dialog
        title="订单详情"
        :visible.sync="dialogShowCurrent"
        width="50%"
        center
        @close="dialogCancel"
      >
        <el-alert
          title="申报信息一旦提交成功后，不可修改！"
          type="warning"
          style="margin-bottom: 10px"
          :closable="false"
        >
        </el-alert>
        <div v-for="(item, index) in fieldArr" :key="index" class="list_item">
          <div class="list_item_key">{{ item.name }}</div>
          <div class="list_item_val">{{ item.value }}</div>
        </div>
        <template v-if="memberArr.length">
          <el-divider content-position="center">人员信息</el-divider>
          <el-card
            class="box-card"
            v-for="(item, index) in memberArr"
            :key="index + 'a'"
          >
            <div
              class="list_item"
              v-for="(item2, index2) in item"
              :key="index2"
            >
              <div class="list_item_key">{{ item2.name }}</div>
              <div class="list_item_val">{{ item2.value }}</div>
            </div>
          </el-card>
        </template>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogCancel">返回修改</el-button>
          <el-button type="primary" @click="dialogConfirm">确 定</el-button>
          <div class="footer_tips"></div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
//订单详情  弹窗
export default {
  name: "OrderDetailDialog",
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    fieldArr: {
      type: Array,
      default: () => {
        return [];
      },
    },
    memberArr: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      dialogShowCurrent: false,
    };
  },
  mounted() {
    this.dialogShowCurrent = this.dialogShow;
  },
  methods: {
    dialogConfirm() {
      this.dialogShowCurrent = false;
      this.$emit("orderDetailDialogConfirm");
    },
    dialogCancel() {
      this.dialogShowCurrent = false;
      this.$emit("orderDetailDialogCancel");
    },
  },
  watch: {
    dialogShow(newval) {
      this.dialogShowCurrent = newval;
    },
  },
};
</script>
<style lang="scss" scoped>
.list_item {
  padding: 10px 0;
  font-size: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .list_item_key {
    margin-right: 15px;
    flex: 1;
  }
  .list_item_val {
    flex: 5;
  }
}
.box-card {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// OrderDetailDialog.vue?0f28902a